import axios from 'axios';

const API_ENDPOINT = '/api/DictionaryService/values/OLBForms,';

export async function fetchLabel(label: string) {
	const result = await axios({
		method: 'GET',
		url: `${API_ENDPOINT}${label}`,
	});
	return result.data;
}
